import axios from "axios";
import { AuthURL } from "../../../config/UrlEndPoint";

export const LOGIN_URL = `${AuthURL}signin`;
export const SUPERADMIN_URL = `${AuthURL}superadmin`;
export const ME_URL = `${AuthURL}me`;

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function superadminLogin(email, password) {
  return axios.post(`${SUPERADMIN_URL}/signin`, { email, password });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export function requestResetPassword(payload) {
  return axios.post(`${AuthURL}request_reset_password`, payload);
}

export function resetPassword(payload) {
  return axios.post(`${AuthURL}reset_password`, payload);
}
